import { Obj } from '../entity.js'
import { RuleEffect, AuthzActionType, Rule } from '../authorizer.js'
import { ObjOptions } from './base.js'

export class SecurityPolicyObj extends Obj<'SecurityPolicy'> {
  readonly typeOf = 'SecurityPolicy' as const

  public constructor(opts: ObjOptions) {
    super({ ...opts, typeOf: 'SecurityPolicy' })
  }
}

export function isSecurityPolicyObj(obj: any): obj is SecurityPolicyObj {
  return obj.typeOf === 'SecurityPolicy'
}

export interface PolicyRuleObjOptions extends ObjOptions {
  effect: RuleEffect
  overrideable: boolean
  applicableActions?: AuthzActionType[]
  applicableEntityTypes?: string[]
  rules?: Rule[]
}

/**
 * PolicyRuleObj - A policy rule object using declarative rules.
 */
export class PolicyRuleObj extends Obj<'PolicyRule'> {
  readonly typeOf = 'PolicyRule' as const
  effect: RuleEffect
  overrideable: boolean
  applicableActions?: AuthzActionType[]
  applicableEntityTypes?: string[]
  rules?: Rule[]

  public constructor(opts: PolicyRuleObjOptions) {
    super({ ...opts, typeOf: 'PolicyRule' })
    this.effect = opts.effect
    this.overrideable = opts.overrideable
    if (opts.applicableActions !== undefined) {
      this.applicableActions = opts.applicableActions
    }
    if (opts.applicableEntityTypes !== undefined) {
      this.applicableEntityTypes = opts.applicableEntityTypes
    }
    if (opts.rules !== undefined) {
      this.rules = opts.rules
    }
  }
}

export function isPolicyRuleObj(obj: any): obj is PolicyRuleObj {
  return obj.typeOf === 'PolicyRule'
}
